function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "288",
  height: "288",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlnsSvgjs: "http://svgjs.com/svgjs"
}, props), /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  width: "288",
  height: "288"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Sales Funnel",
  fill: "red",
  className: (styles["color000"] || "color000") + " " + (styles["svgShape"] || "svgShape")
}, /*#__PURE__*/React.createElement("path", {
  fill: "#35e54a",
  d: "M20.92 24.62A1 1 0 0020 24h-1v-3a1 1 0 00-1-1h-4a1 1 0 00-1 1v3h-1a1 1 0 00-.71 1.71l4 4a1 1 0 001.41 0l4-4a1 1 0 00.22-1.09z",
  className: (styles["colore53a35"] || "colore53a35") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  fill: "#287ec4",
  d: "M29.85 2.47A1 1 0 0029 2H3a1 1 0 00-.89 1.45l2 4A1 1 0 005 8h22a1 1 0 00.89-.55l2-4a1 1 0 00-.04-.98z",
  className: (styles["color70b2e2"] || "color70b2e2") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.82 9.43A1 1 0 0026 9H6a1 1 0 00-.93 1.36l1.54 4a1 1 0 00.93.64h16.92a1 1 0 00.93-.64l1.54-4a1 1 0 00-.11-.93z",
  className: (styles["colorffd54f"] || "colorffd54f") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43b651",
  d: "M23.79 16.39A1 1 0 0023 16H9a1 1 0 00-1 1.26l1.08 4a1 1 0 001 .74h11.84a1 1 0 001-.74l1.08-4a1 1 0 00-.21-.87z",
  className: (styles["color66bb6a"] || "color66bb6a") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  fill: "#35e54a",
  d: "M20.92 24.62A1 1 0 0020 24h-1v-3a1 1 0 00-1-1h-2v10a1 1 0 00.71-.29l4-4a1 1 0 00.21-1.09z",
  className: (styles["colord32e2e"] || "colord32e2e") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  fill: "#287ec4",
  d: "M29.85 2.47A1 1 0 0029 2H16v6h11a1 1 0 00.89-.55l2-4a1 1 0 00-.04-.98z",
  className: (styles["color57a0d7"] || "color57a0d7") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.82 9.43A1 1 0 0026 9H16v6h8.46a1 1 0 00.93-.64l1.54-4a1 1 0 00-.11-.93z",
  className: (styles["colorffcb29"] || "colorffcb29") + " " + (styles["svgShape"] || "svgShape")
}), /*#__PURE__*/React.createElement("path", {
  fill: "#43b651",
  d: "M23.79 16.39A1 1 0 0023 16h-7v6h5.92a1 1 0 001-.74l1.08-4a1 1 0 00-.21-.87z",
  className: (styles["color42a047"] || "color42a047") + " " + (styles["svgShape"] || "svgShape")
})))));